export default "__VITE_ASSET__DOVoeFgt__"